import React, { useState } from 'react'
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import MobileHeader from '../../components/header/MobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import InstituteHeader from '../../components/header/InstituteHeader';
import CRHeader from '../../components/header/CRHeader';
import NonLoginHeader from '../../components/header/NonLoginHeader';
import CandidateHome from '../CandidateHome/CandidateHome';
import Institutehome from '../InstituteHome/Institutehome';
import CRhomepage from '../CRHomePage/CRhomepage';
import NonLoginHome from '../NonLoginHome/NonLoginHome';

const Home = () => {

    const [toggle, setToggle] = useState({
        key: "",
        status: false,
      });
      const [isShowMobile, setShowMobile] = useState(false);
    
      const handleToggle = (key) => {
        if (toggle.key === key) {
          setToggle({
            status: false,
          });
        } else {
          setToggle({
            status: true,
            key,
          });
        }
      };
    
      const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
          ? getMobile.classList.add("modal-menu--open")
          : getMobile.classList.remove("modal-menu--open");
      };
      const module = localStorage.getItem('Module')

      
  return (
    <>
    {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
          module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
              <MobileHeader handleMobile={handleMobile} />}

      {module === 'Candidate' ? <LoginHeader clname="managejobs" handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteHeader clname="managejobs" handleMobile={handleMobile} /> :
          module === 'Company' ? <CRHeader clname="managejobs" handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRHeader clname="managejobs" handleMobile={handleMobile} /> :
              <NonLoginHeader clname="managejobs" handleMobile={handleMobile} />}

      {module === 'Candidate' ? <CandidateHome /> :
       module === 'Institution' ? <Institutehome /> :
        module === 'Company' ? <CRhomepage /> :
         module === 'Recruiter' ? <CRhomepage /> :
         <NonLoginHome />
       }        

    </>
  )
}

export default Home